import httpServer from "../axios";
import {baseUrlt} from "..";

export default {
  createMethod(params) {
    return httpServer('post',`${baseUrlt}api/class/train/log/create`, params);
  },
  createTarinRoom(params){
    return httpServer('post',`${baseUrlt}api/training/room/add`, params);
  },
  createJournalOfClass(params){
    return httpServer('post',`${baseUrlt}api/class/train/class_log/create`, params);
  },
  createJournalOfSX(params){
    return httpServer('post',`${baseUrlt}api/class/charge/train_teacher/create`, params);
  },
  createJournalOfSK(params){
    return httpServer('post',`${baseUrlt}api/class/charge/class_teacher/create`, params);
  },
  createDeviceInto(params){
    return httpServer('post',`${baseUrlt}api/device/add`, params);
  },
  createDeviceBuy(params){
    return httpServer('post',`${baseUrlt}api/devicepurchase/add`, params);
  },
  createDeviceScrap(params){
    return httpServer('post',`${baseUrlt}api/devicescrap/add`, params);
  },
  createDeviceRepair(params){
    return httpServer('post',`${baseUrlt}api/devicerepair/add`, params);
  },
  createDeviceKeep(params){
    return httpServer('post',`${baseUrlt}api/devicekeep/add`, params);
  },
  createDeviceBorrow(params){
    return httpServer('post',`${baseUrlt}api/deviceborrow/add`, params);
  },
  createDeviceLend(params){
    return httpServer('post',`${baseUrlt}api/devicelend/add`, params);
  },
  createDeviceReturn(params){
    return httpServer('post',`${baseUrlt}api/devicereturn/add`, params);
  },
  createDeviceCount(params){
    return httpServer('post',`${baseUrlt}api/devicetotal/add`, params);
  },
  createTrainroomApply(params){
    return httpServer('post',`${baseUrlt}api/room/order/apply`, params);
  },
  createClassPlan(params){
    // return httpServer('post',`${baseUrlt}api/class/plan/create`, params);
    return httpServer('post',`${baseUrlt}api/xmhy/class/plan/create`, params);
  },
  createConsumeInto(params){
    return httpServer('post',`${baseUrlt}api/consume/createUpdate`, params);
  },
  createConsumeUse(params){
    return httpServer('post',`${baseUrlt}api/consume/record/createUpdate`, params);
  },
  createNotice(params){
    return httpServer('post',`${baseUrlt}api/notice/create`, params);
  },
  creatUser(params){
    return httpServer('post',`${baseUrlt}api/user/add`, params);
  },
  creatQItems(params){
    return httpServer('post',`${baseUrlt}api/grade/index/add`, params);
  },
  creatDeviceBind(params){
    return httpServer('post',`${baseUrlt}api/training/room/device/add`, params);
  },
  creatRule(params){
    return httpServer('post',`${baseUrlt}api/training/room/standard/add`, params);
  },
  creatTrainPlan(params){
    return httpServer('post',`${baseUrlt}api/training_plan/add`, params);
  },
  creatTrainPlanV2(params){
    return httpServer('post',`${baseUrlt}api/training_plan/v2/add`, params);
  },
  creatItemConfig(params){
    return httpServer('post',`${baseUrlt}api/training_plan/planScoreItemAdd`, params);
  },
  creatTrainBase(params){
    return httpServer('post',`${baseUrlt}api/training_base/add`, params);
  },
  creatSchool(params){
    return httpServer('post',`${baseUrlt}api/school/admin/add`, params);
  },
  creatTrainRommOpen(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/open/add`, params);
  },
  creatTrainRommCup(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/computer_use/add`, params);
  },
  creatTrainRommFunds(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/funds/add`, params);
  },
  creatTrainBaseOut(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/add`, params);
  },
  creatTrainBaseOutItem(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreItemAdd`, params);
  },
  creatTrainBaseOutYear(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreYearAdd`, params);
  },
  creatPurchaseAdd(params){
    return httpServer('post',`${baseUrlt}api/consume/purchase/add`, params);
  },
  creatDevicePurchaseAdd(params){
    return httpServer('post',`${baseUrlt}api/device/purchase2/add`, params);
  },
  creatLogAdd(params){
    return httpServer('post',`${baseUrlt}api/class/train/log/create`, params);
  },
  submitScore(params){
    return httpServer('post',`${baseUrlt}api/grade/evaluate`, params);
  },
};